(() => {
  if (window.tbvJournalInitialized) return;
  window.tbvJournalInitialized = true;
  const cleanups = new WeakMap();

  function initialize(root) {
    const articles = root.matches?.('[data-tbv-article]') ? [root] : root.querySelectorAll('[data-tbv-article]');
    articles.forEach((article) => {
      cleanups.get(article)?.();
      const body = article.querySelector('[data-article-body]');
      const toc = article.querySelector('[data-article-toc]');
      if (!body || !toc) return;
      const controller = new AbortController();
      const options = { signal: controller.signal };
      const headings = [...body.querySelectorAll('h2')];
      const details = article.querySelector('[data-article-contents]');
      const desktop = window.matchMedia('(min-width: 781px)');
      const syncDetails = () => { if (details) details.open = desktop.matches; };
      syncDetails();
      desktop.addEventListener('change', syncDetails, options);
      toc.replaceChildren();
      headings.forEach((heading, index) => {
        if (!heading.id) heading.id = `${article.id}-heading-${index + 1}`;
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${encodeURIComponent(heading.id)}`;
        link.textContent = heading.textContent;
        item.append(link);
        toc.append(item);
      });
      toc.closest('nav').hidden = headings.length === 0;
      const links = [...toc.querySelectorAll('a')];
      const progress = article.querySelector('[data-reading-progress]');
      const fill = article.querySelector('[data-reading-fill]');
      const percentage = article.querySelector('[data-reading-percent]');
      let frame = 0;
      let activeIndex = -2;
      function update() {
        frame = 0;
        const rect = body.getBoundingClientRect();
        const available = Math.max(1, rect.height - window.innerHeight + 150);
        const value = Math.max(0, Math.min(1, (150 - rect.top) / available));
        if (fill) fill.style.transform = `scaleX(${value})`;
        if (percentage) percentage.textContent = `${Math.round(value * 100)}%`;
        let current = -1;
        headings.forEach((heading, index) => { if (heading.getBoundingClientRect().top <= 170) current = index; });
        if (current !== activeIndex) {
          links.forEach((link, index) => {
            if (index === current) link.setAttribute('aria-current', 'location');
            else link.removeAttribute('aria-current');
          });
          activeIndex = current;
        }
      }
      const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
      window.addEventListener('scroll', schedule, { ...options, passive: true });
      window.addEventListener('resize', schedule, options);
      const resize = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(schedule) : null;
      resize?.observe(body);
      if (progress) progress.hidden = false;
      update();
      const copy = article.querySelector('[data-copy-article]');
      const status = article.querySelector('[data-copy-status]');
      if (copy && navigator.clipboard?.writeText) {
        copy.hidden = false;
        copy.addEventListener('click', async () => {
          const url = new URL(window.location.href);
          url.hash = '';
          [...url.searchParams.keys()].forEach((key) => { if (key !== 'view') url.searchParams.delete(key); });
          try {
            await navigator.clipboard.writeText(url.toString());
            if (status) status.textContent = 'Link copied';
          } catch {
            if (status) status.textContent = 'Copy the address from your browser to share.';
          }
        }, options);
      }
      cleanups.set(article, () => {
        controller.abort();
        resize?.disconnect();
        if (frame) cancelAnimationFrame(frame);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-tbv-article]').forEach((article) => cleanups.get(article)?.());
  });
})();
